export type IkasInvoice = {
  appId: string;
  appName: string;
  createdAt: number | null;
  id: string;
  invoiceNumber: string;
  storeAppId: string;
  type: IkasInvoiceType;
};

export enum IkasInvoiceType {
  COMPANY = "COMPANY",
  INDIVIDUAL = "INDIVIDUAL",
  OTHER = "OTHER",
}
